import { Link } from "react-router-dom";
import { Lock, Unlock, CreditCard, Landmark, LineChart, PiggyBank } from "lucide-react";
import { money } from "@/lib/api";

const icons = { checking: Landmark, investment: LineChart, savings: PiggyBank };

export const AccountTile = ({ acc, i = 0 }) => {
  const Icon = icons[acc.type] || Landmark;
  return (
    <Link to={`/accounts/${acc.id}`} className="tile tile-hover block fade-up" style={{ animationDelay: `${i * 70}ms` }} data-testid={`account-tile-${acc.type}-${i}`}>
      <div className="p-6">
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-blue-50 text-[var(--blue)] grid place-items-center"><Icon size={18} /></div>
          <div>
            <div className="font-display font-semibold text-[var(--navy)]">{acc.name}</div>
            <div className="text-xs text-slate-500 uppercase tracking-wider">{acc.type} ...{acc.number_last4}</div>
          </div>
        </div>
        <div className="mt-6 text-3xl font-display font-bold text-[var(--navy)]" data-testid={`account-balance-${acc.type}-${i}`}>{money(acc.balance)}</div>
        <div className="text-xs text-slate-500 mt-1">Available balance</div>
      </div>
    </Link>
  );
};

export const CardTile = ({ card, i = 0, onToggle }) => (
  <div className="tile tile-hover fade-up" style={{ animationDelay: `${i * 70 + 140}ms` }} data-testid={`card-tile-${i}`}>
    <Link to={`/cards/${card.id}`} className="block p-6 pb-3" data-testid={`card-link-${i}`}>
      <div className="flex items-center gap-3">
        <div className="h-10 w-10 rounded-full bg-red-50 text-[var(--red)] grid place-items-center"><CreditCard size={18} /></div>
        <div>
          <div className="font-display font-semibold text-[var(--navy)]">{card.name}</div>
          <div className="text-xs text-slate-500 uppercase tracking-wider">Credit card ...{card.number_last4}</div>
        </div>
      </div>
      <div className="mt-6 text-3xl font-display font-bold text-[var(--navy)]" data-testid={`card-balance-${i}`}>{money(card.balance)}</div>
      <div className="text-xs text-slate-500 mt-1">Current balance · Available credit {money(card.credit_limit - card.balance)}</div>
    </Link>
    <div className="px-6 pb-5 flex items-center justify-between">
      <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${card.locked ? "bg-red-50 text-[var(--red)]" : "bg-emerald-50 text-emerald-700"}`} data-testid={`card-status-${i}`}>
        {card.locked ? "Locked" : "Active"}
      </span>
      {onToggle && (
        <button onClick={() => onToggle(card)} className="flex items-center gap-1.5 text-sm font-semibold text-[var(--blue)] hover:text-[var(--red)] transition-colors" data-testid={`card-lock-toggle-${i}`}>
          {card.locked ? <><Unlock size={14} /> Unlock card</> : <><Lock size={14} /> Lock card</>}
        </button>
      )}
    </div>
  </div>
);
